import {Component, Input, OnInit} from '@angular/core';
import {User} from "../../../../model/User";
import {PrintNodeOrder} from "../../../../model/PrintNodeOrder";
import {PickSheetService} from "../../../service-data/pick-sheet.service";
import {FacilityService} from "../../../service-data/facility.service";
import {StartupService} from "../../../service-ui/startup.service";
import {ShippingService} from "../../../service-data/shipping.service";
import {Facility} from "../../../../model/Facility";
import {AlertService} from "../../../service-ui/alert.service";
import {LanguagePipe} from "../../../pipe/language.pipe";

@Component({
  selector: 'app-fulfilment-order',
  templateUrl: './fulfillment-order.component.html',
  styleUrls: ['./fulfillment-order.component.css']
})
export class FulfillmentOrderComponent implements OnInit {
  @Input() printNodeOrder: PrintNodeOrder;

  constructor(private startupService: StartupService, private pickSheetService: PickSheetService, private facilityService: FacilityService, private shippingService: ShippingService, private alertService: AlertService) { }

  ngOnInit() {
  }

  printPickSheet ( printNodeOrder: PrintNodeOrder, printer: string ) {
    if ( this.startupService.selectedRole === 'facility') {
      this.facilityService.getItem(Number(this.startupService.selectedRoleId)).subscribe( facility => {
        const printNodeOrderIds = [];
        printNodeOrderIds.push(printNodeOrder.ID);
        this.pickSheetService.createPickAndShipSheets (facility, printNodeOrderIds, printer, 0).subscribe( result => {
        // this.pickSheetService.createPickSheet(facility, printNodeOrder, printer).subscribe( result => {
          console.log(`createdPickSheet for printNodeOrder: ${printNodeOrder.ID} ${printer}`);
        });
      });
    }
  }

  /**
   * Trigger server-side shipping-label generation for every package
   * on this PrintNodeOrder. See
   * `docs/contracts/shared/ShippingLabel.md` and the server-side
   * inbox note `2026-07-20-shipping-label-per-package.md` for the
   * per-package result envelope this handler consumes.
   *
   * The server response now reports per-package success / failure
   * with a `results[]` array plus `successCount` / `failureCount`
   * scalars — surface both to the operator via `AlertService` so a
   * partial failure (e.g. one package's carrier account misconfigured
   * while the rest print fine) doesn't get silently discarded on
   * the console. If the response is missing / null / lacks the new
   * fields (older server, or the stub server-side implementation
   * that predates the READY_FOR_RELEASE note) we fall back to a
   * generic success message.
   */
  printShippingLabels(printNodeOrder: PrintNodeOrder, shippingCarrierAndService: string, printer: string) {
    if ( this.startupService.selectedRole === 'facility') {
      this.facilityService.getItem(Number(this.startupService.selectedRoleId)).subscribe( facility => {
        this.shippingService.createShippingLabels(facility, printNodeOrder, shippingCarrierAndService, printer).subscribe(
          (result: any) => {
            console.log(`createdShipping documents for printNodeOrder: ${printNodeOrder.ID} ${shippingCarrierAndService} ${printer}`, result);
            this.handleShippingLabelResult(printNodeOrder, result);
          },
          (err) => {
            console.error(`Error creating shipping labels for printNodeOrder: ${printNodeOrder.ID}`, err);
            this.alertService.error(
              `${LanguagePipe.get('Failed to create shipping labels for order')} #${printNodeOrder.ID}`
            );
          }
        );
      });
    }
  }

  /**
   * Interpret the `PUT /shippinglabel/...` response envelope
   * (see `shared/ShippingLabel.md`) and raise the right kind of
   * alert. Called only from {@link printShippingLabels}.
   */
  private handleShippingLabelResult(printNodeOrder: PrintNodeOrder, result: any): void {
    if (result === undefined || result === null || result === false) {
      this.alertService.error(
        `${LanguagePipe.get('Failed to create shipping labels for order')} #${printNodeOrder.ID}`
      );
      return;
    }
    // New per-package envelope. `totalPackages`/`successCount`/
    // `failureCount` may be absent on older / stub server responses;
    // treat their absence as "we don't know, assume success".
    const totalPackages = typeof result.totalPackages === 'number' ? result.totalPackages : undefined;
    const successCount = typeof result.successCount === 'number' ? result.successCount : undefined;
    const failureCount = typeof result.failureCount === 'number' ? result.failureCount : undefined;
    const errors: Array<{ package_ID: number; error: string }> = Array.isArray(result.errors) ? result.errors : [];

    if (failureCount !== undefined && failureCount > 0) {
      // Concatenate up to the first few failure lines so the alert
      // stays readable; the full list is in the browser console.
      const preview = errors.slice(0, 3)
        .map(e => `#${e.package_ID}: ${e.error}`)
        .join('; ');
      const more = errors.length > 3 ? ` (+${errors.length - 3} more)` : '';
      const template = LanguagePipe.get('Shipping labels: N of M packages failed');
      // Simple placeholder substitution — keeps the translation
      // catalogue happy while still surfacing the actual numbers.
      const message = template
        .replace('N', String(failureCount))
        .replace('M', String(totalPackages !== undefined ? totalPackages : failureCount + (successCount || 0)))
        + (preview ? ` — ${preview}${more}` : '');
      if (successCount && successCount > 0) {
        // Partial success — warn rather than hard error so the
        // operator sees both the good news and the bad.
        this.alertService.info(message);
      } else {
        this.alertService.error(message);
      }
      return;
    }
    if (totalPackages !== undefined) {
      this.alertService.success(
        `${LanguagePipe.get('Shipping labels queued for printing')} — ${totalPackages}`
      );
    } else {
      this.alertService.success(
        LanguagePipe.get('Shipping labels queued for printing')
      );
    }
  }
  printFreightAddressSheets(printNodeOrder: PrintNodeOrder, printer: string) {
    if ( this.startupService.selectedRole === 'facility') {
      this.facilityService.getItem(Number(this.startupService.selectedRoleId)).subscribe( facility => {
        this.shippingService.createFreightAddressSheets(facility, printNodeOrder, printer).subscribe( result => {
          console.log(`createdShipping documents for printNodeOrder: ${printNodeOrder.ID} ${printer}`);
        });
      });
    }
  }
}
